import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';

import { ORDER_SERVER_URL } from '../../config';
import { ExceptionReportRequest, ExceptionReportResponse } from '../models/exception-report';

const GET_EXCEPITON_REPORT_URL = `${ ORDER_SERVER_URL }/exception-reports`;

@Injectable({ providedIn: 'root' })
export class ExceptionReportService {
	constructor(
		private readonly http: HttpClient
	) {}

	getExceptionReport(
		fields: string | undefined,
		filter: string | undefined,
		orderBy: string | undefined,
		index: number,
		limit: number
	) {
		const url = new URL(GET_EXCEPITON_REPORT_URL);
		const params = url.searchParams;
		if (fields) {
			params.append('fields', fields);
		}
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));
		if (orderBy) {
			params.append('orderBy', orderBy);
		}
		return this.http.get<ExceptionReportResponse[]>(url.toString());
	}

	async addOrUpdateComment(exceptionReportRequest: ExceptionReportRequest[]) {
		const url = new URL(`${ GET_EXCEPITON_REPORT_URL }/save`);
		await firstValueFrom(this.http.post(url.toString(), exceptionReportRequest));
	}

	async deleteComment(docNo: string, origin: string, yearWeek: string) {
		const url = new URL(`${ GET_EXCEPITON_REPORT_URL }/delete`);
		const params = url.searchParams;
		params.append('DocNo', docNo);
		params.append('YearWeek', yearWeek);
		params.append('Origin', origin);
		await firstValueFrom(this.http.post(url.toString(), null));
	}

	getYearWeek() {
		const currentTime = moment();
		const tues6PM = moment().isoWeekday(2).hour(18).minute(0).second(0).millisecond(0);
		return !currentTime.isAfter(tues6PM) ? moment().format('GGGG[W]WW')
			: moment().add(1, 'week').format('GGGG[W]WW');
	}
}
